<script>
import { h, renderSlot } from 'vue'
import ExternalIconWithFallback from '@/common/components/ExternalIconWithFallback'

/**
 * Like ExternalIconWithFallback but with optional `src`.
 * If `src` is falsy, display default slot directly.
 *
 * @since KJS-6520
 */
export default {
  name: 'OptionalExternalIcon',
  props: {
    src: {
      type: [String, null],
      default: null
    },
    title: {
      type: String,
      required: true
    },
    decorative: {
      type: Boolean,
      default: true
    }
  },
  render() {
    if (typeof this.src === 'string') {
      return h(
        ExternalIconWithFallback,
        {
          src: this.src,
          title: this.title,
          decorative: this.decorative
        },
        this.$slots
      )
    }

    return renderSlot(this.$slots, 'default')
  }
}
</script>
